<div
  class="survey-avatar flex items-center justify-center"
  [style.background-color]="color">
  <span [innerHTML]="icon"></span>
</div>
